import React from "react";
import { useTable } from "../../Components/useTable";

const GiftHistoryList = () => {
  const type = "Gifts Sent & Receive History";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "totalDiamond", numeric: false, label: "Total Diamond" },
    { id: "quantity", numeric: false, label: "Quantity" },
    { id: "totalRcoin", numeric: false, label: "Total Rcoin" },
    { id: "UserID", numeric: false, label: "User ID" },
    { id: "UserName", numeric: false, label: "Username" },
    { id: "UserCode", numeric: false, label: "User Code" },
    { id: "pictureUrl", numeric: false, label: "User Image" },
    { id: "TargetID", numeric: false, label: "Target User ID" },
    { id: "TargetName", numeric: false, label: "Target User Name" },
    { id: "TargetCode", numeric: false, label: "Target User Code" },
    { id: "picture", numeric: false, label: "Target User Image" },
    { id: "giftID", numeric: false, label: "Gift ID" },
    { id: "giftName", numeric: false, label: "Gift Name" },
    { id: "giftDiamond", numeric: false, label: "Gift Diamond" },
    { id: "giftType", numeric: false, label: "Gift Type" },
    { id: "assignUserImage", numeric: false, label: "Gift Image" },
    { id: "createdAt", numeric: false, label: "Created at" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default GiftHistoryList;
